const navOffset = () => (document.querySelector("nav")?.getBoundingClientRect().height ?? 0) + 8;

const scrollToEl = (el: Element, behavior: ScrollBehavior) => {
  const y = el.getBoundingClientRect().top + window.scrollY - navOffset();
  window.scrollTo({ top: Math.max(0, y), behavior });
};

/** Scroll to a section below the fixed menu, retrying while lazy sections mount and re-aligning after layout shifts. */
export function scrollToSection(selector: string, tries = 40, fallback?: string) {
  const el = document.querySelector(selector) ?? (tries === 0 && fallback ? document.querySelector(fallback) : null);
  if (el) {
    scrollToEl(el, "smooth");
    [700, 1500, 2500].forEach((ms) =>
      setTimeout(() => {
        if (Math.abs(el.getBoundingClientRect().top - navOffset()) > 60) scrollToEl(el, "auto");
      }, ms),
    );
    return;
  }
  if (tries > 0) setTimeout(() => scrollToSection(selector, tries - 1, fallback), 100);
}

/** Home-page section addresses: path -> section selector. */
export const SECTION_PATHS: Record<string, string> = {
  "/home": "#",
  "/services": "#services",
  "/flotte": "#fleet",
  "/activites": "#activities",
  "/excursion": "#destinations",
  "/reservation": "#booking",
};

export const pathForSection = (selector: string) =>
  Object.keys(SECTION_PATHS).find((p) => SECTION_PATHS[p] === selector) ?? "/home";
